export class NimmstaLayout {
    constructor(xml, parameters = {}) {
        this.parameters = {};
        this.layout = xml;
        this.parameters = parameters;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmltbXN0YUxheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2xheW91dHMvTmltbXN0YUxheW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sYUFBYTtJQUl4QixZQUFZLEdBQVcsRUFBRSxhQUEwQyxFQUFFO1FBRjlELGVBQVUsR0FBaUMsRUFBRSxDQUFDO1FBR25ELElBQUksQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDO1FBQ2xCLElBQUksQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO0lBQy9CLENBQUM7Q0FDRiJ9